import React, { Fragment, useEffect, useState } from 'react';
import List from '@mui/material/List'
import ListItemText from '@mui/material/ListItemText'
import { makeStyles, createStyles } from '@mui/styles';
import { session, setValue, useNavigation } from '../fx';
import * as rolesService from "../../services/RolesService";
import _ from 'lodash';
import { Collapse, ListItemButton } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { TokenContext } from '../../context-helpers/TokenContext';
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";

const SideBar = (props: any) => {
  const { toggleDrawer } = props;
  const classes = useStyles();
  const { getToken } = React.useContext(TokenContext);
  const location = useLocation();

  const defaultMenus: any = [];
  const [menus, setMenus] = useState(defaultMenus);
  const { navigate, clear } = useNavigation();
  const { instance } = useMsal();

  const updateMenus = (data: any) => {
    setMenus((prevState: any) => {
      return [...[], ...data]
    });
  };

  const setAllItemsFalse = (currentItems: any) => {
    let menu = currentItems.find((obj: any) => obj.isSelected == true); // (Masters/Roles) Parent Level
    let menuIndex = currentItems.findIndex((obj: any) => obj.isSelected == true);
    if (menu && menu.isSelected) {
      menu.isSelected = false;
      currentItems.splice(menuIndex, 1, menu);
    };
    for (let item of currentItems) { // (States) Child Level
      if (item.children) {
        let childMenu = item.children.find((obj: any) => obj.isSelected == true);
        let childMenuIndex = item.children.findIndex((obj: any) => obj.isSelected == true);
        if (childMenu && childMenu.isSelected) {
          childMenu.isSelected = false;
          item.children.splice(childMenuIndex, 1, childMenu);
        };
      }
    }
  };

  const selectMenu = (path: any, selectedMenu: any) => {
    clear();
    let currentItems: any = menus;
    setAllItemsFalse(currentItems);
    if (path) {
      setValue(currentItems, path, true);
    } else {
      selectedMenu.isSelected = true;
    }
    updateMenus(currentItems);

    let navData: any = {
      targetRoute: selectedMenu.url,
      targetTitle: selectedMenu.display,
      sourceState: {},
      eventSource: 'sidebar',
    };
    toggleDrawer();
    navigate(navData);
  }

  useEffect(() => {
    getMyControls();
  }, []);

  const getMyControls = async () => {
    try {
      let token: any = await getToken();
      session.setItem("accessToken", token);

      let res = await rolesService.getAssignedControls(token);
      var assignedControls = res["assignedControls"];
      let result: any = [];
      let menuMap: any = {};
      if (assignedControls && assignedControls.length > 0) {
        for (let idx in assignedControls) {
          let item: any = assignedControls[idx];
          if (item) {
            let menu: any = {
              controlCode: item.controlCode,
              display: item.display,
              displayOrder: Number(item.displayOrder),
              url: item.routeRef,
              isSelected: false,
              parentControlCode: item.parentControlCode
            }
            menuMap[item.controlCode] = menu;
          }
        }
        menuMap[res.landingControl.controlCode].isSelected = true;
        for (let key in menuMap) {
          let item: any = menuMap[key];
          if (item.parentControlCode && item.parentControlCode != "-1") {
            let parentMenu: any = menuMap[item.parentControlCode];
            if (parentMenu) {
              parentMenu.children = parentMenu.children || [];
              parentMenu.children.push(item);
            }
          } else {
            result.push(item);
          }
        }
        for (let key in menuMap) {
          let item: any = menuMap[key];
          if (item.children && item.children.length > 0) {
            item.children = _.orderBy(item.children, ['displayOrder'], ['asc']);
            if (item.children && item.children.length > 0) {
              item.isOpen = true;
            }
          }
        }
      }
      setMenus(_.orderBy(result, ['displayOrder'], ['asc']));

      //navigate to user-role landing route
      let landingControl = res["landingControl"];
      let navData = {
        targetRoute: "/dashboard" //landingControl["routeRef"]
      };
      navigate(navData);
    }
    catch (err: any) {
      console.log('getassignedcontrols error' + err.message);
      instance.logoutRedirect();
    }
  };

  const handleClick = (menu: any, index: any) => {
    let currentItems: any = menus;
    menu.isOpen = !menu.isOpen;
    currentItems.splice(index, 1, menu);
    updateMenus(currentItems);
  }

  return (

    <List className={`${classes.menuheight} menuUL`} disablePadding >
      {menus.map((menu: any, index: any) => (
        <Fragment key={index}>
          {menu.children && menu.children.length > 0 &&
            <>
              <ListItemButton sx={{ backgroundColor: "#fafafa" }} onClick={() => handleClick(menu, index)}>
                <ListItemText primary={menu.display} />
                {menu.isOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={menu.isOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {menu.children.map((childItem: any, childItemIndex: any) => (
                    <ListItemButton sx={{ pl: 4 }} selected={childItem.isSelected} key={childItemIndex} onClick={() => selectMenu(index + '.children.' + childItemIndex + '.isSelected', childItem)}>
                      <ListItemText primary={childItem.display} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </>
          }
          {!menu.children &&
            <ListItemButton selected={menu.isSelected} key={index} onClick={() => selectMenu('', menu)}>
              <ListItemText primary={menu.display} />
            </ListItemButton>
          }
        </Fragment>
      ))}
    </List>
  );
}

const drawerWidth = 240;

const useStyles = makeStyles((theme: any) =>
  createStyles({
    menuheight: {
      width: drawerWidth
    },
    menuItem: {
      width: drawerWidth,
    },
    menuItemIcon: {}
  }),
)

export default SideBar;